

import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Button, Table, message } from "antd";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
const defaultDate = moment();
import ExportJsonExcel from 'js-export-excel';

@monthPickerHoc
class PeopleCountModel extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      gridData: [],
      dataSource:[],
      pType:0,
      columns:[]
    };

    
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillReceiveProps(nextProps) {
    var pType = 0;
    if (nextProps.param != null)
    {
      if (nextProps.param.pType != null)
      {
        pType = nextProps.param.pType;
      }
    }
    this.setState(
      {
        gridData: nextProps.param == null ? [] : nextProps.param,
        pType:pType
      }
    );
    var dataSource = [];
    var columns = [];
    if (pType == 6)
    {
      dataSource = nextProps.param && nextProps.param != null && nextProps.param.peopleData != null ? nextProps.param.peopleData : null;
      //根据工单类型整理展示的列表
    columns = [
        {
          title: '名称',
          dataIndex: 'username',
          key: 'username',
          width: 80
        },
        {
          title: '工单总数',
          dataIndex: 'totalNum',
          key: 'totalNum',
          width: 100
        },
        
        {
          title: '工单总时长',
          dataIndex: 'finishTime',
          key: 'finishTime',
          width: 160
        },
        
        {
          title: '平均响应时长',
          dataIndex: 'responseTime',
          key: 'responseTime',
          width: 160
        },
        {
          title: '平均处理时长',
          dataIndex: 'workTime',
          key: 'workTime',
          width: 160
        },
        {
          title: '平均验收时长',
          dataIndex: 'lookTime',
          key: 'lookTime',
          width: 160
        },


        {
          title: '工单总工时',
          dataIndex: 'totalHour',
          key: 'totalHour',
          width: 100
        },
        {
          title: '单工单平均工时',
          dataIndex: 'unitHour',
          key: 'unitHour',
          width: 160
        },
        {
          title: '一次通过率',
          dataIndex: 'rate',
          key: 'rate',
          width: 100
        }];
        if (nextProps.param && nextProps.param != null && nextProps.param.pieList != null)
        {
          for (var i=0; i<nextProps.param.pieList.length;i++)
          {
            var data = nextProps.param.pieList[i];
            columns.push({
              title: data.ticketPriorityName + '工单数量',
              dataIndex: data.levelType  + 'num',
              key: data.levelType  + 'num',
              width: 120
            });
            columns.push({
              title: data.ticketPriorityName + '处理时长',
              dataIndex: data.levelType  + 'hour',
              key: data.levelType  + 'hour',
              width: 120
            });
          }
        }
    } else if (pType == 1)
    {
      if (nextProps.param && nextProps.param != null && nextProps.param.data != null )
      {
        var data = nextProps.param.data;
        var map = {};
        for(var i = 0; i < data.length; i++){
          var ai = data[i];
          if(!map[ai.userId]){
            map[ai.userId] = {
              userId: ai.userId,
              username: ai.username,
              totalNum:ai.totalNum,
              totalHour:ai.totalHour,
              num11:0,
              num12:0,
              num13:0,
              num14:0,
              num15:0
            };
            if (ai.ticketType === 11)
            {
              map[ai.userId].num11 += ai.totalNum;
            } else if (ai.ticketType === 12)
            {
              map[ai.userId].num12 += ai.totalNum;
            } else if (ai.ticketType === 13)
            {
              map[ai.userId].num13 += ai.totalNum;
            } else if (ai.ticketType === 14)
            {
              map[ai.userId].num14 += ai.totalNum;
            } else if (ai.ticketType === 15)
            {
              map[ai.userId].num15 += ai.totalNum;
            } 
          }else{
            if (ai.ticketType === 11)
            {
              map[ai.userId].num11 += ai.totalNum;
            } else if (ai.ticketType === 12)
            {
              map[ai.userId].num12 += ai.totalNum;
            } else if (ai.ticketType === 13)
            {
              map[ai.userId].num13 += ai.totalNum;
            } else if (ai.ticketType === 14)
            {
              map[ai.userId].num14 += ai.totalNum;
            } else if (ai.ticketType === 15)
            {
              map[ai.userId].num15 += ai.totalNum;
            } 
            map[ai.userId].totalNum = map[ai.userId].totalNum + ai.totalNum;
            map[ai.userId].totalHour = map[ai.userId].totalHour + ai.totalHour
          }
        }
        var pieList = [];
        if (map != null)
        {
          var i = 0;
          for (var key in map) {
            pieList.push(map[key]);
          }
        }
        dataSource = pieList;
      }
      //  dataSource
      //根据工单类型整理展示的列表
    columns = [
        {
          title: '人员',
          dataIndex: 'username',
          key: 'username',
          width: 80
        },
        {
          title: '处理工单数量',
          dataIndex: 'totalNum',
          key: 'totalNum',
          width: 100
        },
        {
          title: '工时总数',
          dataIndex: 'totalHour',
          key: 'totalHour',
          width: 100
        },
        {
          title: '故障工单数量',
          dataIndex: 'num11',
          key: 'num11',
          width: 100
        },
        {
          title: '巡检工单数量',
          dataIndex: 'num12',
          key: 'num12',
          width: 100
        },
        {
          title: '调试工单数量',
          dataIndex: 'num13',
          key: 'num13',
          width: 100
        },
        {
          title: '通用工单数量',
          dataIndex: 'num15',
          key: 'num15',
          width: 100
        },
        {
          title: '验收工单数量',
          dataIndex: 'num14',
          key: 'num14',
          width: 100
        }];
    } else if (pType == 2)
    {
      
      if (nextProps.param && nextProps.param != null && nextProps.param.data != null )
      {
        var data = nextProps.param.data;
        var map = {};
        for(var i = 0; i < data.length; i++){
          var ai = data[i];
          if(!map[ai.stationId]){
            map[ai.stationId] = {
              stationId: ai.stationId,
              stationName: ai.stationName,
              totalNum:ai.totalNum,
              num11:0,
              num12:0,
              num13:0,
              num14:0,
              num15:0
            };
            if (ai.ticketType === 11)
            {
              map[ai.stationId].num11 += ai.totalNum;
            } else if (ai.ticketType === 12)
            {
              map[ai.stationId].num12 += ai.totalNum;
            } else if (ai.ticketType === 13)
            {
              map[ai.stationId].num13 += ai.totalNum;
            } else if (ai.ticketType === 14)
            {
              map[ai.stationId].num14 += ai.totalNum;
            } else if (ai.ticketType === 15)
            {
              map[ai.stationId].num15 += ai.totalNum;
            } 
          }else{
            if (ai.ticketType === 11)
            {
              map[ai.stationId].num11 += ai.totalNum;
            } else if (ai.ticketType === 12)
            {
              map[ai.stationId].num12 += ai.totalNum;
            } else if (ai.ticketType === 13)
            {
              map[ai.stationId].num13 += ai.totalNum;
            } else if (ai.ticketType === 14)
            {
              map[ai.stationId].num14 += ai.totalNum;
            } else if (ai.ticketType === 15)
            {
              map[ai.stationId].num15 += ai.totalNum;
            } 
            map[ai.stationId].totalNum = map[ai.stationId].totalNum + ai.totalNum
          }
        }
        var pieList = [];
        if (map != null)
        {
          var i = 0;
          for (var key in map) {
            pieList.push(map[key]);
          }
        }
        dataSource = pieList;
      }
      //  dataSource
      //根据工单类型整理展示的列表
    columns = [
        {
          title: '电站名称',
          dataIndex: 'stationName',
          key: 'stationName',
          width: 100
        },
        {
          title: '产生工单数量',
          dataIndex: 'totalNum',
          key: 'totalNum',
          width: 100
        },
        {
          title: '故障工单数量',
          dataIndex: 'num11',
          key: 'num11',
          width: 100
        },
        {
          title: '巡检工单数量',
          dataIndex: 'num12',
          key: 'num12',
          width: 100
        },
        {
          title: '调试工单数量',
          dataIndex: 'num13',
          key: 'num13',
          width: 100
        },
        {
          title: '通用工单数量',
          dataIndex: 'num15',
          key: 'num15',
          width: 100
        },
        {
          title: '验收工单数量',
          dataIndex: 'num14',
          key: 'num14',
          width: 100
        }];
    }else if (pType == 3)
    {
      if (nextProps.param && nextProps.param != null && nextProps.param.data != null )
      {
        var data = nextProps.param.data;
        var map = {};
        for(var i = 0; i < data.length; i++){
          var ai = data[i];
          if(!map[ai.stuId]){
            map[ai.stuId] = {
              stuId: ai.stuId,
              stuName: ai.stuName,
              totalNum:ai.totalNum,
              num11:0,
              num12:0,
              num13:0,
              num14:0,
              num15:0
            };
            if (ai.ticketType === 11)
            {
              map[ai.stuId].num11 += ai.totalNum;
            } else if (ai.ticketType === 12)
            {
              map[ai.stuId].num12 += ai.totalNum;
            } else if (ai.ticketType === 13)
            {
              map[ai.stuId].num13 += ai.totalNum;
            } else if (ai.ticketType === 14)
            {
              map[ai.stuId].num14 += ai.totalNum;
            } else if (ai.ticketType === 15)
            {
              map[ai.stuId].num15 += ai.totalNum;
            } 
          }else{
            if (ai.ticketType === 11)
            {
              map[ai.stuId].num11 += ai.totalNum;
            } else if (ai.ticketType === 12)
            {
              map[ai.stuId].num12 += ai.totalNum;
            } else if (ai.ticketType === 13)
            {
              map[ai.stuId].num13 += ai.totalNum;
            } else if (ai.ticketType === 14)
            {
              map[ai.stuId].num14 += ai.totalNum;
            } else if (ai.ticketType === 15)
            {
              map[ai.stuId].num15 += ai.totalNum;
            } 
            map[ai.stuId].totalNum = map[ai.stuId].totalNum + ai.totalNum
          }
        }
        var pieList = [];
        if (map != null)
        {
          var i = 0;
          for (var key in map) {
            pieList.push(map[key]);
          }
        }
        dataSource = pieList;
      }
      //  dataSource
      //根据工单类型整理展示的列表
    columns = [
        {
          title: '设备编号',
          dataIndex: 'stuId',
          key: 'stuId',
          width: 100
        },
        {
          title: '产生工单数量',
          dataIndex: 'totalNum',
          key: 'totalNum',
          width: 100
        },
        {
          title: '故障工单数量',
          dataIndex: 'num11',
          key: 'num11',
          width: 100
        },
        {
          title: '巡检工单数量',
          dataIndex: 'num12',
          key: 'num12',
          width: 100
        },
        {
          title: '调试工单数量',
          dataIndex: 'num13',
          key: 'num13',
          width: 100
        },
        {
          title: '通用工单数量',
          dataIndex: 'num15',
          key: 'num15',
          width: 100
        },
        {
          title: '验收工单数量',
          dataIndex: 'num14',
          key: 'num14',
          width: 100
        }];
    }else if (pType == 4)
    {
      if (nextProps.param && nextProps.param != null && nextProps.param.data != null )
      {
        var data = nextProps.param.data;
        var map = {};
        for(var i = 0; i < data.length; i++){
          var ai = data[i];
          var code = ai.code;
          var codeName = ai.codeName;
          if (code == null || code == 'null')
          {
            code = '未知'
            codeName = '未知'
          }
          if (code == '1')
          {
            codeName = '模块环温相差告警';
          } else if (code == '2')
          {
            codeName = '模块温度不均衡告警';
          } else if (code == '3')
          {
            codeName = '模块高温限流告警';
          } else if (code == '4')
          {
            codeName = '模块电流不均衡告警';
          } else if (code == '5')
          {
            codeName = '模块配置异常告警';
          } else if (code == '6')
          {
            codeName = '异常扣费订单告警';
          } else if (code == '7')
          {
            codeName = '连续异常订单告警';
          } else if (code == '8')
          {
            codeName = '充电桩频繁掉线告警';
          } else if (code == '9')
          {
            codeName = '充电桩长时掉线告警';
          }
          if(!map[ai.code]){
            
            map[ai.code] = {
              code: code,
              codeName: codeName,
              totalNum:ai.totalNum,
            };
          }else{
            map[ai.code].totalNum = map[ai.code].totalNum + ai.totalNum
          }
        }
        var pieList = [];
        if (map != null)
        {
          var i = 0;
          for (var key in map) {
            pieList.push(map[key]);
          }
        }
        dataSource = pieList;
      }
    columns = [
        {
          title: '故障描述',
          dataIndex: 'code',
          key: 'code',
          width: 100
        },
        {
          title: '故障原因',
          dataIndex: 'codeName',
          key: 'codeName',
          width: 100
        },
        {
          title: '派单数量',
          dataIndex: 'totalNum',
          key: 'totalNum',
          width: 100
        }];
    }
        this.setState(
          {
            columns:columns,
            dataSource:dataSource
          }
        )
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    componentWillMount() {
    }


    fetchApi = (params) => {
      let result = {
        ...params,
      };
      if (params.month) {
        result = {
          ...result,
          month: params.month.format("YYYYMM"),
        };
      }
      return result;
    };

    getCaptcha = () => {
      if (!this.state.dataSource || this.state.dataSource == null || this.state.dataSource.length  == 0)
      {
        message.error("暂无数据");
        return;
      }
    var data = this.state.dataSource ? this.state.dataSource : '';//表格数据
      var option={};
      let dataTable = [];
      if (data) {
        for (let i in data) {
          if(data){
            let obj = {}
            for (let j in this.state.columns)
            {
              obj[this.state.columns[j].title] = data[i][this.state.columns[j].dataIndex];
              
            }
            dataTable.push(obj);
          }
        }
      }
      var header = [];
      for (var i=0; i<this.state.columns.length; i++)
      {
        header.push(this.state.columns[i].title);
      }
      option.fileName = '人效指标'
      option.datas=[
        {
          sheetData:dataTable,
          sheetName:'sheet',
          sheetFilter:header,
          sheetHeader:header,
        }
      ];

      var toExcel = new ExportJsonExcel(option); 
      toExcel.saveExcel(); 
    };

    render() {
      const columns = this.state.columns;
      const dataSource = this.state.dataSource;
      const content = (
        <div>
          <div style={{display:'flex',alignItems: 'center'}}>
          {this.state.pType == 6 ? (
              <span style={{fontSize:'16px', marginRight:'20px'}}>人员概览</span>
	) : null}
            
            
            {this.state.pType == 6 ? (
              <Button onClick={this.getCaptcha} disabled={this.state.captchaBtnDisabled} type="primary">导出</Button>
	) : null}
          </div>
        <div className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column", marginTop: "25px", overflow: "auto" }}>
          <div className="page-panel">
            {/* <ScGridTable config={this.state.tableConfig} /> */}

            <Table dataSource={dataSource} columns={columns}  pagination={{ position: ['top', 'None'], pageSize:dataSource == null || dataSource.length == 0 ? 10 : dataSource.length }}/>
          </div>
        </div>
        </div>
      );
      return (
        content)
    }
}

export default PeopleCountModel;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/peopleCountModel.js